"use client";
import React, { useState, useRef, useEffect, useCallback, useMemo, useLayoutEffect } from "react";
import { Link, useLocation } from "react-router-dom";
// import Image from "next/image";
import { Sidebar } from "primereact/sidebar";
import { Dropdown } from "primereact/dropdown";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { FileUpload } from "primereact/fileupload";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import downvector from '../../../assets/images/DownVector.svg';
import orangevector from '../../../assets/images/orangeVector.svg';
import arrowleft from '../../../assets/images/arrow-left.png';
import arrowright from '../../../assets/images/arrow-right.png';
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import TopLinesChart from "../charts/toplineschart";
import { color } from "echarts";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { fetchAttendance_table_popup, fetchDimension_view, fetchSchools, fetchStaff_wise_popup, fetchTable_view, fetchTop_Absence_table_popup } from "../../../redux/slices/staffdetails";
import { useDispatch, useSelector } from "react-redux";
import LoaderContainer from "../../../components/LoaderContainer/LoaderContainer";
import { xlsxExport } from "../../../components/chartwrapper/excelDownload";
import { fetchMenu_School_Year } from "../../../redux/slices/filter";
import { InputSwitch } from "primereact/inputswitch";
import { InputText } from "primereact/inputtext";

export default function StaffSideBar(props) {
    const { visible, onHide, setActiveIndexList, data, tile } = props;
    const [activeTab, setActiveTab] = useState(0);
    const handleTabClick = (index) => {
        setActiveTab(index);
    };
    const [selectedMetric, setSelectedMetric] = tile;
    const [selectedDimension, setSelectedDimension] = useState( {name:"School Type", code:"school_type"} );
    const [selectedYear, setSelectedYear] = useState(null);
    useLayoutEffect(() => {
        setSelectedYear({name:`${selectedMetric?.value?.SCHOOL_YEAR}`, code: selectedMetric?.value?.SCHOOL_YEAR});
    }, [visible, tile])
    const [visibleDetailTable, setVisibleDetailTable] = useState(false);
    const [selectedSchool, setSelectedSchool] = useState({});

    /* Redux State */
    const dispatch = useDispatch();
    // Local
    const Schools = useSelector(state => state.staffdetails.Schools);
    const SchoolsLoading = useSelector(state => state.staffdetails.Schoolsloading);
    const Table_view = useSelector(state => state.staffdetails.Table_view);
    const Table_viewloading = useSelector(state => state.staffdetails.Table_viewloading);
    const Dimension_view = useSelector(state => state.staffdetails.Dimension_view);
    const Dimension_viewloading = useSelector(state => state.staffdetails.Dimension_viewloading);

    // Dropdown Year Option
    const Menu_School_Yeardata = useSelector(state => state.filter.Menu_School_Year);
    // Filter
    const appliedfilter = useSelector(state => state.filter.appliedFilters);
    
    /* */

    /* Filters */
    const Appliedfilters = useMemo(() => {
        const filters = appliedfilter;
        const ignore = new Set(["GRADE", "STUDENT_ELL", "STUDENT_ECONOMICALLY_DISADVANTAGED", "STUDENT_SPECIAL_ABILITY"]) 
        return filters.filter(({ columnName }) => !ignore.has(columnName)); 
    }, [appliedfilter])
    /* */

    /* API Calls */
    useEffect(() => {
    if(visible){
        dispatch(fetchSchools({
            "elasticQueryName": "Schools",
            "filters": Appliedfilters,
            "dynamicColumns": [
                    { "columnName": "#{metric_id}", "columnValue": selectedMetric?.value?.METRIC_ID},
            ],
        }));
        dispatch(fetchTable_view({
            "elasticQueryName": "Table_view",
            "filters": Appliedfilters,
            "dynamicColumns": [
                    { "columnName": "#{metric_id}", "columnValue": selectedMetric?.value?.METRIC_ID},
            ],
        }));
        dispatch(fetchMenu_School_Year({
            "elasticQueryName": "Menu_School_Year",
            "filters": [],
            "dynamicColumns": [], 
        }))
    }
    }, [visible, selectedMetric, Appliedfilters])
    useEffect(() =>{
        if(visible){
            dispatch(fetchDimension_view({
                "elasticQueryName": "Dimension_view",
                "filters": [ 
                    {"columnName": "SCHOOL_YEAR", "columnValue": selectedYear.code, "excludeKeyword": false },
                ].concat(Appliedfilters.filter(({ columnName }) => columnName != 'SCHOOL_YEAR')),
                "dynamicColumns": [ 
                    { "columnName": "#{metric_id}", "columnValue": selectedMetric?.value?.METRIC_ID},
                    { "columnName": "#{dimension}", "columnValue": selectedDimension.code} 
                ],
            }));
        }
    }, [visible, selectedMetric, selectedYear, selectedDimension, Appliedfilters])

    /* */
    
    const DimensionOpt = [
        {name:"School Type", code:"school_type"},
        {name:"Staff Gender", code:"student_gender"},
        {name:"Staff Ethnicity", code:"student_ethnicity"},
        // {name:"Staff Type", code:"placement_type"},
        // {name:"", code:""}
    ]
    
    /* Year Option */
    var yearOptions = [];
    Menu_School_Yeardata?.forEach(year => {
        const endYear = year.SCHOOL_YEAR?.toString().split('-')[1]; // gets "2025"
        yearOptions.push({ 'name': endYear?.toString(), 'code': Number(endYear) })
    })
    /* */

    let sliderRef = useRef(null);
    const next = () => {
        sliderRef.slickNext();
    };
    const previous = () => {
        sliderRef.slickPrev();
    };
    const settings = {
        dots: false,
        arrows: true,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        initialSlide: 0,
        centerMode: false,
    };

    const DropdownOpt = data

    const staffdata = [
        {
          staffid: "10122",
          staffname: "Alan",
          role: "Admin",
          gender: "Male",
          absences: "24"
        },
        {
          staffid: "10232",
          staffname: "Alex",
          role: "Support",
          gender: "Female",
          absences: "12"
        },
        {
          staffid: "10232",
          staffname: "Alex",
          role: "Support",
          gender: "Female",
          absences: "12"
        },
        {
          staffid: "10232",
          staffname: "Alex",
          role: "Support",
          gender: "Female",
          absences: "12"
        },
        {
          staffid: "10232",
          staffname: "Alex",
          role: "Support",
          gender: "Female",
          absences: "12"
        },
    ];

    const handleSchoolClick = (rowData) => {
        // if (selectedMetric?.value?.METRIC_ID == 10047) {
            setSelectedSchool(rowData);
            setVisibleDetailTable(true);
        // }
    };
    const schoolNameTemplate = (rowData) => (
        <span
            style={{ cursor: 'pointer' }}
            onClick={() => handleSchoolClick(rowData)}
        >
            <u>{rowData.SCHOOL_OFFICIAL_NAME}</u>
        </span>
    );

    // Function that returns display name based on METRIC_ID using switch    
    const getHeader = (metricId) => {
        switch (metricId) {
            case 10111:
                return '10-Year Retention Rate';
            case 10050:
                return '1-Year Retention Rate';
            case 10047:
                return 'Absent Rate';
            case 10048:
                return '# of Staff';
            default:
                return selectedMetric.value?.METRIC_NAME?.replace("Staff ", "");
        }
    };

    const SideBarHeading = {
        10111 : '10-Year Retention Rate',
        10050 : '1-Year Retention Rate',
        10047 : 'Staff Absenteeism',
        10048 : 'Total Staff',
    }

    const TableFilterTemplate = (options) => {
        return (
            <div className="relative flex items-center">
                <i className="pi pi-search absolute left-3 text-gray-500 text-sm"></i>
                <InputText
                    value={options.value}
                    onChange={(e) => options.filterCallback(e.target.value)}
                    placeholder="Search here"
                    className="pl-10 pr-3 py-1.5 border border-blue-300 rounded-md w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
            </div>
        );
    };
    return (
        <>
            <Sidebar
                visible={visible}
                onHide={onHide}
                position="right"
                className="custmSidebar 2xl:w-[18.75vw] bg-[#15181F]"
                blockScroll={true}
            >
                <div className="p-[20px]">
                    <div className="text-[24px] text-[#fff] leading-[24px] font-semibold ">{SideBarHeading[selectedMetric.value?.METRIC_ID]}</div>
                </div>
                <div className="bg-[#272321] px-[20px] flex items-center justify-between ">
                    <div className="text-[20px] text-[#fff] ">Metric Overview</div>
                    <div className="custedit rounded">
                        <div className="custDrop">
                        <Dropdown
                            // value={''}
                            // options={['one', 'two', 'three']}
                            // optionLabel="name"
                            // placeholder="Teacher Retention Rate"

                            value={selectedMetric.value}
                            optionLabel="METRIC_NAME"
                            options={DropdownOpt}
                            onChange={(e) => setSelectedMetric({...selectedMetric, value: e.value})}
                            placeholder="Select Metric"
                            className="side_drop"
                            panelClassName="customdrop"
                        />
                        </div>
                    </div>
                </div>
                <div className="p-[20px]">
                    <div className="bg-[#272321] rounded-[6px] px-2 py-2 mb-5 ">
                        <div className="text-[18px] text-[#D6D6D6] leading-[18px] mb-3">{selectedMetric.value?.METRIC_MET_LABEL}</div>
                        <div className="flex gap-2 items-center mb-3">
                            <div className="text-[28px] text-[#fff] leading-[30px] ">{selectedMetric.value?.METRIC_ID == 10048 ? selectedMetric.value?.CURRENT_YEAR?.toFixed(0) : selectedMetric.value?.CURRENT_YEAR?.toFixed(1) + '%'}</div>
                            {/* <div className="bg-[#D9685B] rounded-[25px] text-[14px] text-[#fff] px-2 py-1 flex gap-1.5 ">LY Var &nbsp; {selectedMetric.value?.VARIANCE}% <img src={downvector} /></div> */}
                            {selectedMetric.value?.VARIANCE == 0 ?
                                <div className="bg-[#db685b] rounded-[25px] text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 whitespace-nowrap ">LY Var &nbsp; -% <i className="pi pi-sort-down-fill" style={{color: 'white'}}></i></div>
                                :
                            selectedMetric.value?.VARIANCE < 0 ?
                                <div className="bg-[#db685b] rounded-[25px] text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 whitespace-nowrap ">LY Var &nbsp; {selectedMetric.value?.VARIANCE?.toFixed(2)}% <i className="pi pi-sort-down-fill" style={{color: 'white'}}></i></div>
                                :
                                <div className="bg-[#129C83] rounded-[25px] text-[12px] text-[#EEEEF0] px-2 py-1 flex gap-1.5 whitespace-nowrap ">LY Var &nbsp; {selectedMetric.value?.VARIANCE?.toFixed(2)}% <i className="pi pi-sort-up-fill"></i></div>
                            }
                        </div>
                        <div className="flex gap-4">
                            {/* <div className="w-1/2">
                                <div className="text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Target</div>
                                <div className="text-[20px] leading-[24px] text-[#fff] ">{selectedMetric.value?.TARGET || '-'}%</div>
                            </div> */}
                            <div className="">
                                <div className="text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">LY Value</div>
                                <div className="text-[20px] leading-[24px] text-[#fff] ">{(selectedMetric.value?.METRIC_ID == 10048 ? selectedMetric.value?.LAST_YEAR?.toFixed(0) : selectedMetric.value?.LAST_YEAR?.toFixed(1)) || '-'}</div>
                            </div>
                        </div>
                    </div>
                    <div className="mb-5">
                        <div className="flex items-center justify-between">
                            <div className="text-[16px] text-[#fff] leading-[16px] mb-2 ">Schools</div>
                            <div className="flex gap-2 items-center">
                                <img src={arrowleft} onClick={previous}/>
                                <img src={arrowright} onClick={next}/>
                            </div>
                        </div>
                        <div className="gap-3 w-full sidebar_slick">
                        <LoaderContainer loading={SchoolsLoading} height={'100px'} width={'100%'}>
                        <Slider ref={slider => {
                    sliderRef = slider;
                }}
                    {...settings} className="">
                        {Schools.map(item => {
                            return(
                            <div className="bg-[#272321] w-1/2 rounded-[6px] px-2 py-2 mr-3 ">
                                <div className="text-[16px] text-[#D6D6D6] leading-[16px] mb-3">{item?.SCHOOL_TYPE}</div>
                                <div className="flex justify-between">
                                    <div className="">
                                        <div className="text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Current</div>
                                        <div className="text-[24px] leading-[24px] text-[#fff] ">{selectedMetric.value?.METRIC_ID == 10048 ? item?.CURRENT_YEAR?.toFixed(0) : item?.CURRENT_YEAR?.toFixed(1)+'%'}</div>
                                    </div>
                                    <div className="">
                                        <div className="text-[14px] text-[#fff] leading-[14px] pb-1.5 ">LY Var</div>
                                        {item?.LAST_VARIANCE == 0 ?
                                            <div className="text-[14px] leading-[18px] text-[#fff] flex gap-1 ">-% <i className="pi pi-sort-down-fill" style={{color: '#db685b'}}></i></div>
                                            :
                                            item?.LAST_VARIANCE < 0 ?
                                            <div className="text-[14px] leading-[18px] text-[#fff] flex gap-1 ">{selectedMetric.value?.METRIC_ID == 10048 ? item?.LAST_VARIANCE?.toFixed(0) : item?.LAST_VARIANCE?.toFixed(0)+'%'} <i className="pi pi-sort-down-fill" style={{color: '#db685b'}}></i></div>
                                            :
                                            <div className="text-[14px] leading-[18px] text-[#fff] flex gap-1 ">{selectedMetric.value?.METRIC_ID == 10048 ? item?.LAST_VARIANCE?.toFixed(0) : item?.LAST_VARIANCE?.toFixed(0)+'%'} <i className="pi pi-sort-up-fill" style={{color: '#129C83'}}></i></div>
                                        }
                                    </div>
                                </div>
                            </div>)})
                        }
                            {/* <div className="bg-[#272321] w-1/2 rounded-[6px] px-2 py-2 ">
                                <div className="text-[16px] text-[#D6D6D6] leading-[16px] mb-3">Secondary Schools</div>
                                <div className="flex justify-between">
                                    <div className="">
                                        <div className="text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Current</div>
                                        <div className="text-[24px] leading-[24px] text-[#fff] ">74</div>
                                    </div>
                                    <div className="">
                                        <div className="text-[14px] text-[#fff] leading-[14px] pb-1.5 ">LY Var</div>
                                        <div className="text-[14px] leading-[18px] text-[#fff] flex gap-1 ">-5.9% <img src={orangevector} /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="bg-[#272321] w-1/2 rounded-[6px] px-2 py-2 ">
                                <div className="text-[16px] text-[#D6D6D6] leading-[16px] mb-3">Secondary Schools</div>
                                <div className="flex justify-between">
                                    <div className="">
                                        <div className="text-[14px] text-[#D6D6D6] leading-[14px] pb-1.5 ">Current</div>
                                        <div className="text-[24px] leading-[24px] text-[#fff] ">74</div>
                                    </div>
                                    <div className="">
                                        <div className="text-[14px] text-[#fff] leading-[14px] pb-1.5 ">LY Var</div>
                                        <div className="text-[14px] leading-[18px] text-[#fff] flex gap-1 ">-5.9% <img src={orangevector} /></div>
                                    </div>
                                </div>
                            </div> */}
                            </Slider>
                        </LoaderContainer>
                        </div>
                    </div>
                    <div className="">
                        <div className="mb-[30px]">
                            <Tabs selectedIndex={activeTab} onSelect={handleTabClick}>
                                <TabList>
                                    <div className="flex gap-3 items-center">
                                        <Tab>
                                            <div className={`text-[16px]  leading-[18px] px-4 py-3  rounded-full cursor-pointer ${ activeTab === 0 ? "text-[#272321] bg-[#fff]" : "text-[#fff] bg-[#272321]" } `}>
                                                Dimension View
                                            </div>
                                        </Tab>
                                        <Tab>
                                            <div className={`text-[16px]  leading-[18px] px-4 py-3  rounded-full cursor-pointer ${ activeTab === 1 ? "text-[#272321] bg-[#fff]" : "text-[#fff] bg-[#272321]" } `}>
                                                Table View
                                            </div>
                                        </Tab>
                                    </div>
                                </TabList>
                            </Tabs>
                        </div>
                        <div className="">
                            <Tabs 
                                selectedIndex={activeTab} 
                                onSelect={handleTabClick} 
                                style={{ width: "100%" }}
                            >
                                <TabPanel>
                                    <div className="bg-[#272321] rounded-[6px] ">
                                        <div className="text-[16px] text-[#fff] px-4 py-3 border-b border-[#374151] ">{selectedMetric.value?.METRIC_MET_LABEL}</div>
                                        <div className="flex justify-end gap-2">
                                            <div className="bg-[#0F0D0B] text-[#E0E3E9] text-[11px] py-[7px] pl-[10px] rounded-b-[6px] ">
                                                <span>Year: </span>
                                                <Dropdown
                                                    value={selectedYear}
                                                    // options={['2021-2022', '2022-2023', '2023-2024']}
                                                    onChange={(e) => setSelectedYear(e.value)}
                                                    options={yearOptions}
                                                    optionLabel="name"
                                                    placeholder="Select year"
                                                    className="tab_drop"
                                                    panelClassName="customdrop"
                                                />
                                            </div>
                                            <div className="bg-[#0F0D0B] text-[#E0E3E9] text-[11px] py-[7px] pl-[10px] rounded-b-[6px] ">
                                                <span>Dimension: </span>
                                                <Dropdown
                                                    value={selectedDimension}
                                                    options={DimensionOpt}
                                                    onChange={(e) => setSelectedDimension(e.value)}
                                                    optionLabel="name"
                                                    placeholder="Select dimension"
                                                    className="tab_drop"
                                                    panelClassName="customdrop"
                                                />
                                            </div>
                                        </div>
                                        <div className="h-[300px]">
                                            <LoaderContainer loading={Dimension_viewloading} height={'100%'} width={'100%'}>
                                            <TopLinesChart
                                                tooltip={{
                                                    show: true,
                                                    confine: true,
                                                }} 
                                                grid={{
                                                    top: '10%',
                                                    left: '15%',
                                                    right: '0%',
                                                    bottom: '20%',
                                                  }}
                                                legend={{
                                                    show: true,
                                                    bottom: 15,
                                                    padding:[0,0,0,20],
                                                    left: 'start',
                                                    itemGap: 4,
                                                    itemWidth: 8,
                                                    itemHeight: 8,
                                                    textStyle: {
                                                        color: '#E0E3E9',
                                                        fontSize: 10
                                                    },
                                                    data: [ 'School'],
                                                }}

                                                xaxisdata={Dimension_view?.map(item => item?.DIMENSION)}
                                                xAxisName={"School"}
                                                xAxisNameGap={"30"}
                                                xAxisNamePosition={"center"}
                                                xaxisLabel={{
                                                    interval: 0,
                                                    fontSize: 12,
                                                    formatter: function (value) {
                                                        return value.length > 5 ? value.substring(0,5) + "..." : value;
                                                    },
                                                    color: '#344054',
                                                    textStyle: {
                                                      color: "#E0E3E9"
                                                    }
                                                }}
                                                xaxisTick={{
                                                    show: false,
                                                }}
                                                xaxisLine={{
                                                    show: true,
                                                    lineStyle: {
                                                        color: "#374151"
                                                    }
                                                }}

                                                // min={'0'}
                                                // max={'100'}
                                                // interval={10}
                                                // yAxisName={selectedMetric.value?.METRIC_NAME == "Staff Retention Rate" ? "Teacher Retention Rate (%)" : selectedMetric.value?.METRIC_NAME == "Staff Demographics" ? "# of Staff" : selectedMetric.value?.METRIC_NAME == "Staff Attendance Rate" ? "Absent Rate" : '% of Teachers Reaching Milestone'}
                                                yAxisName={getHeader(selectedMetric?.value?.METRIC_ID)}
                                                yAxisNameGap={"50"}
                                                yAxisNamePosition={"middle"}
                                                yaxisLabel={{
                                                    show: true,
                                                    formatter: selectedMetric.value?.METRIC_ID == 10048 ? "{value}" : "{value}%",
                                                    color: '#E0E3E9',
                                                    fontSize: 12
                                                }}
                                                yaxisLine={{
                                                show: true,
                                                lineStyle: {
                                                    color: "#374151"
                                                }
                                                }}
                                                yaxisSplitlines={{
                                                show: true,
                                                lineStyle: {
                                                    type: 'dashed',
                                                    color: '#344054',
                                                }
                                                }}
                                                name='School'
                                                // data={[74, 54.5, 78, 70.2, 80.9]}
                                                data={selectedMetric.value?.METRIC_ID == 10048 ? Dimension_view.map(item => item?.CURRENT_YEAR?.toFixed(0)) : Dimension_view.map(item => item?.CURRENT_YEAR?.toFixed(1))}
                                                barWidth={'60%'}
                                                itemStyle={{
                                                    color: '#79543A',
                                                    borderRadius: [3, 3 ,0, 0],
                                                }}
                                                label={{
                                                    show: true,
                                                    position: 'top',
                                                    color: '#fff',
                                                    formatter: selectedMetric.value?.METRIC_ID == 10048 ? "{c}" : "{c}%",
                                                    fontSize: 12,
                                                    fontWeight: 400,
                                                    padding: [0, 0, 0, 0],
                                                }}
                                            />
                                            </LoaderContainer>
                                        </div>
                                    </div>
                                </TabPanel>
                                <TabPanel>
                                    <div className="bg-[#272321] ">
                                        <div className="flex justify-between items-center px-4 py-3 ">
                                            <div className="text-[16px] text-[#fff] leading-[24px] ">{selectedMetric.value?.METRIC_MET_LABEL}</div>
                                            <button onClick={()=>xlsxExport({filename: selectedMetric.value?.METRIC_NAME == "Staff Retention Rate" ? "10-Year Retention Rate" : "1-Year Retention Rate", data : Table_view})} className="bg-[#1A1A1A] text-[#fff] text-[16px] leading-[16px] px-2 py-3 border border-[#374151] rounded-[6px] ">Export</button>
                                        </div>
                                        <div className="">
                                            <LoaderContainer loading={Table_viewloading} height={'200px'} width={'100%'}>
                                            <DataTable
                                                dataKey={'SCHOOL_ID'}
                                                value={Table_view}
                                                className="staffTable"
                                                // scrollable
                                                // scrollHeight="400px" 
                                                style={{ width: "100%"}}
                                                >
                                                <Column
                                                    field="SCHOOL_YEAR"
                                                    header="School Year"
                                                    // style={{ maxWidth: "4rem" }}
                                                    sortable
                                                    filter
                                                    showFilterMenuOptions={false}
                                                    filterElement={TableFilterTemplate}
                                                    filterMenuClassName="custfilter"
                                                ></Column>
                                                {/* {schoolNames.map((schoolName, index) => (
                                                <Column key={index} field={schoolName} header={schoolName}
                                                style={{ minWidth: "12rem" }}
                                                ></Column>
                                                ))} */}
                                                {/* <Column
                                                    field="SCHOOL_ID"
                                                    header="School ID"
                                                    // style={{ minWidth: "8rem" }}
                                                    sortable
                                                    filter
                                                    showFilterMenuOptions={false}
                                                    filterElement={TableFilterTemplate}
                                                    filterMenuClassName="custfilter"
                                                ></Column> */}
                                                <Column
                                                    field="SCHOOL_OFFICIAL_NAME"
                                                    header="Location Name"
                                                    // style={{ minWidth: "8rem" }}
                                                    body={schoolNameTemplate}
                                                    sortable
                                                    filter
                                                    showFilterMenuOptions={false}
                                                    filterElement={TableFilterTemplate}
                                                    filterMenuClassName="custfilter"
                                                ></Column>
                                                <Column
                                                    field="CURRENT_YEAR"
                                                    header={`${getHeader(selectedMetric.value?.METRIC_ID)}`}
                                                    // style={{ minWidth: "8rem" }}
                                                    body={(rowData) => `${rowData?.METRIC_ID == 10048 ? rowData.CURRENT_YEAR?.toFixed(0) : rowData.CURRENT_YEAR?.toFixed(2)+'%'}`}
                                                    sortable
                                                    filter
                                                    showFilterMenuOptions={false}
                                                    filterElement={TableFilterTemplate}
                                                    filterMenuClassName="custfilter"
                                                ></Column>
                                                {/* <Column
                                                    field="VALUE"
                                                    header="# of Staff"
                                                    // style={{ minWidth: "8rem" }}
                                                    body={(row) => row?.VALUE?.toFixed(0)}
                                                ></Column> */}
                                            </DataTable>
                                            </LoaderContainer>
                                        </div>
                                    </div>
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </div>
            </Sidebar>
            <Sidebar visible={visibleDetailTable} onHide={() => setVisibleDetailTable(false)} 
            position="bottom"
            className="bottomBar w-full bg-[#15181F]"
            blockScroll={true}>
                {visibleDetailTable && <StaffWise schoolName={selectedSchool?.SCHOOL_OFFICIAL_NAME} MetricId={selectedMetric.value?.METRIC_ID} title={selectedMetric.value?.METRIC_MET_LABEL}/>}
            </Sidebar>
        </>
    )
}
function StaffWise(props) {
    const {MetricId, schoolName, title} = props

    // Local States
    const [showreason, setshowreason] = useState(false);

    // API Data's
    const Attendance_table_popup = useSelector(state => state.staffdetails.Attendance_table_popup);
    const Attendance_table_popuploading = useSelector(state => state.staffdetails.Attendance_table_popuploading);
    const Top_Absence_table_popup = useSelector(state => state.staffdetails.Top_Absence_table_popup);
    const Top_Absence_table_popuploading = useSelector(state => state.staffdetails.Top_Absence_table_popuploading);

    const Staff_wise_popup = useSelector(state => state.staffdetails.Staff_wise_popup);
    const Staff_wise_popuploading = useSelector(state => state.staffdetails.Staff_wise_popuploading);

    // Filters
    const appliedfilter = useSelector(state => state.filter.appliedFilters);
    const Appliedfilters = useMemo(() => {
        const filters = appliedfilter;
        const ignore = new Set(["GRADE", "STUDENT_ELL", "STUDENT_ECONOMICALLY_DISADVANTAGED", "STUDENT_SPECIAL_ABILITY"])
        return filters.filter(({ columnName }) => !ignore.has(columnName));
    }, [appliedfilter])

    // API Calls
    const dispatch = useDispatch();
    useEffect(() => {
        if (MetricId == 10047) {
            dispatch(fetchAttendance_table_popup({
                "elasticQueryName": "Attendance_table_popup",
                "filters": [{ "columnName": "SCHOOL_OFFICIAL_NAME", "columnValue": schoolName, "excludeKeyword": false }].concat(Appliedfilters),
                "dynamicColumns": [],
            }));

            dispatch(fetchTop_Absence_table_popup({
                "elasticQueryName": "Top_Absence_table_popup",
                "filters": [{ "columnName": "SCHOOL_OFFICIAL_NAME", "columnValue": schoolName, "excludeKeyword": false }].concat(Appliedfilters),
                "dynamicColumns": [],
            }));
        }
    }, [Appliedfilters, showreason])

    useEffect(() => {
        dispatch(fetchStaff_wise_popup({
            "elasticQueryName": "Staff_wise_popup",
            "filters": [
                { "columnName": "SCHOOL_OFFICIAL_NAME", "columnValue": schoolName, "excludeKeyword": false },
                { "columnName": "METRIC_ID", "columnValue": MetricId, "excludeKeyword": false },
            ].concat(Appliedfilters),
            "dynamicColumns": [],
        }));
    }, [Appliedfilters])

    const TableData = MetricId == 10047 ? showreason ? Top_Absence_table_popup : Attendance_table_popup : Staff_wise_popup;
    const TableDataloading = MetricId == 10047 ? showreason ? Top_Absence_table_popuploading : Attendance_table_popuploading : Staff_wise_popuploading;

    const TableFilterTemplate = (options) => {
        return (
            <div className="relative flex items-center">
                <i className="pi pi-search absolute left-3 text-gray-500 text-sm"></i>
                <InputText
                    value={options.value}
                    onChange={(e) => options.filterCallback(e.target.value)}
                    placeholder="Search here"
                    className="pl-10 pr-3 py-1.5 border border-blue-300 rounded-md w-full text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
                />
            </div>
        );
    };

    return (<>
        <div className="p-[30px] pb-0">
            <div className="mb-[30px] flex justify-between">
                <div className="text-[20px] text-[#fff] pl-[130px] pt-[10px] ">{title}</div>
                <div className="flex gap-6 items-center text-[#fff]">
                    {MetricId == 10047 && <div className="">
                        <InputSwitch
                            checked={showreason}
                            onChange={(e) => {
                                e.stopPropagation();
                                setshowreason(e.value)
                            }}
                            className="staffcheckbox ml-8"
                        />
                        <div className="text-[10px]">
                            (Include Absence Reason)
                        </div>
                    </div>}
                    <div>
                        {/* <span onClick={() => setshowreason(!showreason)} style={{ backgroundColor: showreason ? "green" : "red", color: "white", padding: '1rem 2rem', cursor: "pointer"}}>{showreason ? "Active" : "Not Active"}</span> */}
                        <button onClick={() => xlsxExport({ filename: "Staff Absenteesim - (StaffWise)", data: TableData })} className="bg-[#2E265A] text-[16px] leading-[16px] text-[#fff] rounded-full px-4 py-4 shadow ">Export XLS</button>
                    </div>
                </div>
            </div>
            <div className="bg-[#1a2025cc] p-1.5">
                <div className="text-[16px] text-[#fff] leading-[24px] px-4 py-2">Detailed View of - {title}</div>
                <div className="h-full">
                    <LoaderContainer loading={TableDataloading} height={'300px'} width={'100%'}>
                        <DataTable
                            // dataKey={'STAFF_ID'}
                            value={TableData}
                            className="staffTable"
                            scrollHeight="24.5rem"
                            paginator // Paginator Enable
                            rows={10} // Number of rows per page
                            rowsPerPageOptions={[10, 20, 30]} // Options in Paginator Dropdown
                            scrollable
                            // scrollHeight="400px"
                            style={{ width: "100%" }}
                        >
                            <Column
                                field="STAFF_ID"
                                header="Staff ID"
                                // style={{ maxWidth: "4rem" }}
                                sortable
                                filter
                                showFilterMenuOptions={false}
                                filterElement={TableFilterTemplate}
                                filterMenuClassName="custfilter"
                            ></Column>
                            <Column
                                field="STAFF_NAME"
                                header="First Name"
                                // style={{ minWidth: "8rem" }}
                                sortable
                                filter
                                showFilterMenuOptions={false}
                                filterElement={TableFilterTemplate}
                                filterMenuClassName="custfilter"
                            ></Column>
                            <Column
                                field="LAST_NAME"
                                header="Last Name"
                                // style={{ minWidth: "8rem" }}
                                sortable
                                filter
                                showFilterMenuOptions={false}
                                filterElement={TableFilterTemplate}
                                filterMenuClassName="custfilter"
                            ></Column>
                            <Column
                                field="ROLE"
                                header="Role"
                                // style={{ minWidth: "8rem" }}
                                sortable
                                filter
                                showFilterMenuOptions={false}
                                filterElement={TableFilterTemplate}
                                filterMenuClassName="custfilter"
                            ></Column>
                            {/* <Column
                                field="LOCATION"
                                header="Location"
                                // style={{ minWidth: "8rem" }}
                                sortable
                            ></Column> */}
                            <Column
                                field="GENDER"
                                header="Gender"
                                // style={{ minWidth: "8rem" }}
                                sortable
                                filter
                                showFilterMenuOptions={false}
                                filterElement={TableFilterTemplate}
                                filterMenuClassName="custfilter"
                            ></Column>
                            <Column
                                field="ETHNICITY"
                                header="Ethnicity"
                                // style={{ minWidth: "8rem" }}
                                sortable
                                filter
                                showFilterMenuOptions={false}
                                filterElement={TableFilterTemplate}
                                filterMenuClassName="custfilter"
                            ></Column>
                            {showreason && <Column
                                field="ABSENCE_REASON"
                                header="Absence Reason"
                                // style={{ minWidth: "8rem" }}
                                sortable
                                filter
                                showFilterMenuOptions={false}
                                filterElement={TableFilterTemplate}
                                filterMenuClassName="custfilter"
                            ></Column>}
                            {MetricId == 10047 && <Column
                                field="NO_OF_DAYS"
                                header="# of Days Absence"
                                // style={{ minWidth: "8rem" }}
                                sortable
                                filter
                                showFilterMenuOptions={false}
                                filterElement={TableFilterTemplate}
                                filterMenuClassName="custfilter"
                                // className="hltcolor"
                            ></Column>}
                            {MetricId == 10047 && <Column
                                field="PERCENTAGE"
                                header="% of Days"
                                // style={{ minWidth: "8rem" }}
                                body={(rowData) => `${rowData.PERCENTAGE?.toFixed(2)}%`}
                                sortable
                                filter
                                showFilterMenuOptions={false}
                                filterElement={TableFilterTemplate}
                                filterMenuClassName="custfilter"
                                // className="hltcolor"
                            ></Column>}
                        </DataTable>
                    </LoaderContainer>
                </div>
            </div>
        </div>
    </>)
}